/* Muscle IQ product page helpers — ported from the prototype (swipe gallery with thumbnails,
   section bar scrollspy, sticky add-to-cart on mobile). Shared by all product templates. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function initGallery(g) {
    if (g._init) return; g._init = true;
    var root = g.closest('.gal-col') || g.parentNode;
    var track = $('[data-g-track]', g), bar = $('[data-g-bar]', g), thumbs = $('[data-g-thumbs]', root);
    var slides = $$('.g-slide', track), i = 0;
    function mark() {
      if (bar) $$('i', bar).forEach(function (b, k) { b.classList.toggle('on', k === i); });
      if (thumbs) $$('button', thumbs).forEach(function (b, k) { b.setAttribute('aria-current', k === i); });
      /* thumbnails in one sliding row: keep the current one in view */
      if (thumbs && thumbs.scrollWidth > thumbs.clientWidth) { var cur = $$('button', thumbs)[i]; if (cur) thumbs.scrollTo({ left: Math.max(0, cur.offsetLeft - (thumbs.clientWidth - cur.offsetWidth) / 2), behavior: 'smooth' }); }
    }
    function show(n, instant) {
      i = (n + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      mark();
    }
    track.addEventListener('scroll', function () { var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (n !== i) { i = n; mark(); } }, { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); } });
    $$('[data-g]', g).forEach(function (b) { b.addEventListener('click', function () { show(i + (+b.dataset.g)); }); });
    if (bar) bar.addEventListener('click', function (e) { var t = e.target.closest('i'); if (t) show(+t.dataset.i); });
    if (thumbs) thumbs.addEventListener('click', function (e) { var t = e.target.closest('button'); if (t) show(+t.dataset.i); });
    mark();
    g._api = {
      show: show, index: function () { return i; },
      /* find a slide by media id or by alt text containing a word (e.g. a colour name) */
      showMedia: function (mediaId) { var k = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); }); if (k > -1) { show(k); return true; } return false; },
      showAlt: function (word) {
        /* whole-word match only, so "Red" no longer matches "group:shared". An exact "…-colour-red" style alt wins. */
        if (!word) return false; word = String(word).toLowerCase().trim();
        var esc = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '[\\s_-]+');
        var re = new RegExp('(^|[^a-z0-9])' + esc + '($|[^a-z0-9])');
        var alts = slides.map(function (s) { return (s.dataset.alt || '').toLowerCase(); });
        var k = alts.findIndex(function (a) { return /colou?r/.test(a) && re.test(a); });
        if (k < 0) k = alts.findIndex(function (a) { return re.test(a); });
        if (k > -1) { show(k); return true; } return false;
      },
      /* temporary image swap on the first slide (used when an option has its own image) */
      preview: function (src, alt) {
        var img = $('img', slides[0]); if (!img || !src) return;
        if (!img.dataset.orig) { img.dataset.orig = img.currentSrc || img.src; img.dataset.origSrcset = img.getAttribute('srcset') || ''; }
        img.removeAttribute('srcset'); img.src = src; if (alt) img.alt = alt; show(0);
      },
      reset: function () { var img = $('img', slides[0]); if (img && img.dataset.orig) { img.src = img.dataset.orig; if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset); } }
    };
  }

  function initSubnav(nav) {
    if (nav._init) return; nav._init = true;
    /* universal product page: links are built from the details blocks actually on the page */
    if (nav.hasAttribute('data-auto')) {
      var box = $('nav', nav), secs = $$('[data-pd-anchor]');
      if (!secs.length) { nav.hidden = true; return; }
      box.innerHTML = secs.map(function (s) { return '<a href="#' + s.id + '" data-sec="' + s.id + '">' + s.getAttribute('data-pd-anchor').replace(/[<>&"]/g, '') + '</a>'; }).join('');
    }
    var last = null, links = $$('nav a', nav), ids = links.map(function (a) { return a.dataset.sec; });
    function spy() {
      var y = window.scrollY + 170, on = ids[0];
      ids.forEach(function (id) { var el = document.getElementById(id); if (el && el.getBoundingClientRect().top + window.scrollY <= y) on = id; });
      links.forEach(function (a) { a.classList.toggle('on', a.dataset.sec === on); });
      /* keep the current link in view when the bar scrolls sideways (phones) */
      if (on !== last) { last = on; var cur = links.filter(function (a) { return a.dataset.sec === on; })[0], sc = cur && cur.parentNode;
        if (sc && sc.scrollWidth > sc.clientWidth) sc.scrollTo({ left: Math.max(0, cur.offsetLeft - (sc.clientWidth - cur.offsetWidth) / 2), behavior: 'smooth' }); }
    }
    window.addEventListener('scroll', spy, { passive: true }); spy();
  }

  function initSticky(bar) {
    if (bar._init) return; bar._init = true;
    var row = $('[data-rack-atc-row], [data-atc-row]');
    function upd() {
      if (!row) return;
      var r = row.getBoundingClientRect();
      var show = innerWidth <= 760 && (r.bottom < 0 || r.top > innerHeight - 70);
      bar.classList.toggle('show', show); bar.setAttribute('aria-hidden', !show);
      /* the chat button moves above this bar (miq-theme.js liftChat) */
      if (window.MIQ && MIQ.liftChat) MIQ.liftChat();
    }
    window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    bar.addEventListener('transitionend', function () { if (window.MIQ && MIQ.liftChat) MIQ.liftChat(); });
  }

  function init(scope) {
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-subnav]', scope).forEach(initSubnav);
    $$('[data-satc]', scope).forEach(initSticky);
  }
  window.MIQProduct = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

